export const SHIPPING_INFO_STEP = 'shipping';
export const DELIVERY_METHODS_STEP = 'deliveryMethods';
export const PAYMENT_STEP = 'payment';
export const REVIEW_STEP = 'review';

export const TEALIUM_SHIPPING_STEP = 'Shipping';
export const TEALIUM_DELIVERY_STEP = 'Delivery';
export const TEALIUM_PAYMENT_STEP = 'Payment';
export const TEALIUM_VERIFY_ADDRESS_STEP = 'Verify Your Shipping Address';

export const SHIPPING_BLOCK = 'shipping';
export const BILLING_BLOCK = 'billing';
export const PAYMENT_BLOCK = 'payment';
export const DELIVERY_BLOCK = 'delivery';
export const SHIPPING_ADDRESS_ERROR = 'ORD-002';
export const SHIPPING_METHOD_ERROR = 'ORD-003';
export const BILLING_ADDRESS_ERROR = 'BILL-006';
export const ITEMS_NOT_DELIVERABLE_ERROR = 'ORD-006';
export const ITEMS_NOT_DELIVERABLE_CART_ERROR = 'CARTS-004';
export const PAYMENT_ERROR = 'PH-002';
export const PAYMENT_SESSION_AUTHORIZATION_ERROR = 'PH-003';
export const CARD_TOKEN_ERROR = 'NO-TOKEN-DATA';
export const PAYMENT_DATA_NOT_COMPLETE_ERROR = 'NO_CC_PAYMENT_DATA';
export const CARD_TOKENIZATION_ERROR = 'CC_TOKENIZATION_ERROR';
export const ORDER_FAILED = 'ORD-004';
export const ORDER_FRAUD_ERROR = 'ORD-005';
export const ZIP_ERROR = 'ZIP_ERROR';
export const SHIPPING_ADDRESS_UNEXPECTED_ERROR = 'ADDRESS_ERROR';
export const BILLING_ADDRESS_UNEXPECTED_ERROR = 'BILLING_ADDRESS_ERROR';
export const GIFT_CARD_ONLY_PAYMENT_ERROR = 'GIFT_CARD_ONLY_PAYMENT_ERROR ';
export const PAYMENT_ERROR_DECLINED_GIFT_CARD = 'PH-011';
export const SHIPPING_ADDRESS_STATE_NOT_ALLOWED = 'CARTS-016';
export const SLEEP_COUNTRY_CANADA = 'Sleep Country Canada';
export const SLEEP_COUNTRY_CANADA_URL = 'https://www.sleepcountry.ca/';
export const MATTRESS_PRODUCT_TYPE_KEY = 'mattress-type';
export const COUPON_CODE_VALIDITY_ERROR_ORDERS = 'ORD-020';
export const COUPON_CODE_VALIDITY_ERROR_CART = 'CARTS-021';
export const TRUEMED_PAYMENT_ERROR = 'PH-014';
export const SHIPPING_ADDRESS_INVALID_PO_BOX = 'ADDRESS_PO_BOX_ERROR';
